import { isEmpty } from '../../../utils'
export const autoNumberProps = {
  value: {
    type: [String, Number],
    default: ''
  },
  isPureText: {
    type: Boolean,
    default: false
  },
  size: {
    type: String,
    default: 'small'
  }
}

// 初始化纯文本
export function initValue (value) {  
  return isEmpty(value) ? '-' : value
}